import { createStore } from 'satcheljs';
export default createStore('txpOption', {
    CreateEventsFromEmailAsPrivate: null,
    EventsFromEmailEnabled: null,
    Events: {
        DiningEventsFromEmailEnabled: null,
        EntertainmentEventsFromEmailEnabled: null,
        FlightEventsFromEmailEnabled: null,
        HotelEventsFromEmailEnabled: null,
        InvoiceEventsFromEmailEnabled: null,
        PackageDeliveryEventsFromEmailEnabled: null,
        RentalCarEventsFromEmailEnabled: null,
    },
})();
//# sourceMappingURL=store.js.map